enum LocalStorageKeys {
  CONNECTOR = 'satsWagmiConnector'
}

export { LocalStorageKeys };
